import "./TabView.css";
import { IoAdd } from "react-icons/io5";
import { FiUpload } from "react-icons/fi";


function normalizeTab(tab) {
	if (typeof tab === "string") {
		return { id: tab, label: tab };
	}

	return {
		id: tab.id,
		label: tab.label ?? tab.id,
		disabled: Boolean(tab.disabled),
	};
}

function TabView({
	tabs = [],
	views = {},
	activeTab,
	onTabChange,
	actions = [],
	ariaLabel = "Tabs",
	className = "",
	tabsClassName = "",
	contentClassName = "",
}) {
	const normalizedTabs = tabs.map(normalizeTab);
	const currentTab = normalizedTabs.find((tab) => tab.id === activeTab) || normalizedTabs[0] || null;
	const activeView = currentTab ? views[currentTab.id] : null;

    const icons = {
        add: <IoAdd />,
        upload: <FiUpload />,
    }
	return (
		<div className={`tab-view ${className}`.trim()}>
			<div className="tab-view__header">
				<div className={`tab-view__tabs ${tabsClassName}`.trim()} role="tablist" aria-label={ariaLabel}>
					{normalizedTabs.map((tab) => (
						<button
							key={tab.id}
							type="button"
							className={`tab-view__tab${currentTab?.id === tab.id ? " is-active" : ""}`}
							onClick={() => onTabChange?.(tab.id)}
							aria-pressed={currentTab?.id === tab.id}
							disabled={tab.disabled}
						>
							{tab.label}
						</button>
					))}
				</div>
				{actions.length > 0 && (
					<div className="tab-view__actions">
						{actions.map((action) => (
							<button
								key={action.id}
								type="button"
								className={`tab-view-button${action.active ? " is-active" : ""} ${action.color ? `tab-view-button--${action.color}` : ""}`.trim()}
								onClick={action.onClick}
								disabled={action.disabled}
							>
								{action.icon && <span className="tab-view-button__icon">{icons[action.icon]}</span>}
								{action.label}
							</button>
						))}
					</div>
				)}
			</div>
			<div className={`tab-view__content ${contentClassName}`.trim()}>
				{activeView}
			</div>
		</div>
	);
}

export default TabView;